import React, { useEffect, useState } from "react";

const AlumniSection = ({ alumni }) => {
  const [selectedAlumni, setSelectedAlumni] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (alumni && alumni.length > 0) {
      setSelectedAlumni(alumni[0]);
    }
  }, [alumni]);

  const handleRowClick = (item) => {
    setSelectedAlumni(item);
    setIsPlaying(false);
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  if (!selectedAlumni) return null;

  return (
    <section className="mrv-alumni-premium py-5">
      <div className="container">
        {/* Heading */}
        <div className="mb-3 text-left">
          <span className="mrv-subtitle">Our Pride</span>
          <h2 className="mrv-title">Alumni Success Stories</h2>
        </div>

        <div className="row g-4 align-items-stretch">
          {/* LEFT Featured */}
          <div className="col-lg-7">
            <div className={`featured-alumni ${isPlaying ? "playing" : ""}`}>
              
              {/* IMAGE */}
              {!isPlaying && (
                <img
                  src={selectedAlumni.thumbnail}
                  alt={selectedAlumni.name}
                  className="w-100"
                  loading="lazy"
                />
              )}

              {/* VIDEO
              {isPlaying && selectedAlumni.video && (
                <video
                  src={selectedAlumni.video}
                  preload="none"
                  className="w-100"
                  autoPlay
                  controls
                />
              )} */}

              {/* OVERLAY */}
              {!isPlaying && (
                <div className="featured-overlay">
                  <span className="featured-tag">
                    {selectedAlumni.batch}
                  </span>

                  <h3>{selectedAlumni.name}</h3>

                  <p> {selectedAlumni.title}</p>

                  {/* button optional */}
                  {/* 
                  {selectedAlumni.video && (
                    <button className="play-btn" onClick={handlePlay}>
                      Watch Story
                    </button>
                  )} 
                  */}
                </div>
              )}
            </div>
          </div>

          {/* RIGHT LIST */}
          <div className="col-lg-5">
            <div className="alumni-list">
              {alumni.map((item) => (
                <div
                  key={item.id}
                  className={`alumni-row ${
                    selectedAlumni.id === item.id ? "active" : ""
                  }`}
                  onClick={() => handleRowClick(item)}
                >
                  <img
                    src={item.thumbnail}
                    alt={item.name}
                    loading="lazy"
                  />

                  <div>
                    <h6>{item.name}</h6>

                    <span>
                      {item.title} • {item.batch}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlumniSection;